import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogClickMarketMore = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({ name: 'CLICK_MARKET_MORE' });
  }, [logAnalyticsEvent]);
};
